import { getReportParams, report } from 'app/middleware/report';
import EpiContext from '@episerver/spa-core/Spa';

const reportActionTypeDictionary = {
  AbroadData: "AbroadDataGuide",
  AbroadCellular: "AbroadCallsGuide",
};

function reportAbroadWizard({
  process,
  param1 = '',
  status = '',
  messageText = '',
}) {
  const selectedSubscriber = EpiContext.getStore().getState().selfcarePage?.selectedSubscriber;
  const idNumber = EpiContext.getStore().getState().authentication?.loginData?.userDetails?.IDNumber;
  const reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'Support';
  reportParams.subArea = 'SupportGuides';
  reportParams.actionType = `${reportActionTypeDictionary[process] ?? 'AbroadWizard'} Page`;
  reportParams.status = status;
  reportParams.messageText = messageText;
  reportParams.param1 = param1;
  reportParams.customerName = `${selectedSubscriber?.productFirstName ?? ''} ${selectedSubscriber?.productLastName ?? ''}`;
  reportParams.subscriber = selectedSubscriber?.productSubscriberNo ?? '';
  reportParams.idNumber = idNumber ?? '';
  report(reportParams);
}

export function dwhAbroadWizardEntrance(args) {
  reportAbroadWizard({
    ...args,
    status: 'Ongoing',
    messageText: `${reportActionTypeDictionary[args.process]} Start Running`,
  });
}

export function dwhAbroadWizardAllChecksFinished(args) {
  reportAbroadWizard({
    ...args,
    status: 'Completed',
    messageText: `${reportActionTypeDictionary[args.process]} Answer Display`,
  });
}

export function dwhAbroadWizardFinishedWithError(args) {
  reportAbroadWizard({
    ...args,
    status: 'Error',
    messageText: `${reportActionTypeDictionary[args.process]} General Error`,
  });
}

export function dwhAbroadWizardButtonClicked(args) {
  reportAbroadWizard({
    ...args,
    status: 'Ongoing',
    messageText: `${reportActionTypeDictionary[args.process]} Action Link Clicked`,
  });
}
